import React from "react";
import Modal from "../../../../components/Modal/Modal";
import ErrorIcon from "@material-ui/icons/Error";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button/Button";
function DeleteWebhook({ setOpen, deleteFunc, setRefresh }) {
  const { t } = useTranslation();

  const handleClose = () => {
      setOpen(false);
  }

  const handleDeleteConfirm = () => {
      //delete
      deleteFunc();
      setRefresh(old => !old)
      setOpen(false);
  }
  return (
    <div>
      <Modal setOpen={setOpen} title={t('CONTENT.WEBHOOK.DELETE-RULE')}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ErrorIcon style={{ color: "#D75E5E", width: 40, height: 40 }} />
        </div>
        <div
          style={{
            color: "#8C90A2",
            fontSize: 14,
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 10,
            marginTop:10,
            textAlign: "center"
          }}
        >
          <div style={{ width: 284 }}>
            {t("CONTENT.WEBHOOK.DELETE-WARNING-MESSAGE")}
          </div>
        </div>
        <div
          style={{
            color: "#8C90A2",
            fontSize: 13,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 25,
            textAlign: "center"
          }}
        >
          <div style={{ width: 284 }}>
            {t("CONTENT.WEBHOOK.DELETE-WARNING-INFO")}
          </div>
        </div>
        <div style={{display:"flex", alignItems: "center", justifyContent: "space-around",marginBottom:15}}>
        <Button 
            value={t('CONTENT.WEBHOOK.DELETE')}
            bgColor="auRed"
            onClick={handleDeleteConfirm}
        />
          <Button 
            value={t('CONTENT.WEBHOOK.CANCEL')}
            onClick={handleClose}
        />
        </div>
      </Modal>
    </div>
  );
}

DeleteWebhook.propTypes = {
  setOpen: PropTypes.func,
  deleteFunc : PropTypes.func,
  setRefresh : PropTypes.func,
};

export default DeleteWebhook;
